import { useReset } from 'app/components/reset/useReset'
import { ResetShadcnComponent } from 'app/components/reset/ResetShadcnComponent'

export default function Reset() {
  const { email, code, success, error, isSubmitting, onSubmit } = useReset()

  return (
    <ResetShadcnComponent
      email={email}
      code={code}
      success={success}
      error={error}
      isSubmitting={isSubmitting}
      onSubmit={onSubmit}
    />
  )
}
